<script setup lang="ts">
defineProps<{
  onLogout:() => void;
  fetchingLogout: boolean;
}>();

const uuid = defineModel<string>('uuid', { required: true });
</script>
<template>
  <LayoutLoggedBase>
    <template #sidebar>
      <LayoutSidebar
        v-model:uuid="uuid"
        :on-logout="onLogout"
      />
    </template>
    <template #header>
      <Header v-model:uuid="uuid" :on-logout="onLogout" />
    </template>
    <template #content>
      <slot name="content" />
    </template>
    <template #aside>
      <!-- This is temp code to make MMA match with design -->
      <!-- This code will be removed after design is updated -->
      <div class="p-6 rounded-md shadow-md bg-white border-2 border-gray-200">
        <h3 class="uppercase text-[#353030] text-[16px] font-semibold mb-4 flex gap-2 items-center">
          <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_10219_8795)">
              <!-- eslint-disable-next-line vue/max-len -->
              <path d="M8.31179 1C7.65495 1 7.12429 1.53066 7.12429 2.1875V2.9C4.4153 3.44922 2.37429 5.84648 2.37429 8.71875V9.41641C2.37429 11.1605 1.7323 12.8453 0.574485 14.1516L0.299876 14.4596C-0.0118431 14.8084 -0.0860619 15.3094 0.103196 15.7361C0.292454 16.1629 0.719211 16.4375 1.18679 16.4375H15.4368C15.9044 16.4375 16.3274 16.1629 16.5204 15.7361C16.7134 15.3094 16.6354 14.8084 16.3237 14.4596L16.0491 14.1516C14.8913 12.8453 14.2493 11.1643 14.2493 9.41641V8.71875C14.2493 5.84648 12.2083 3.44922 9.49929 2.9V2.1875C9.49929 1.53066 8.96862 1 8.31179 1ZM9.99284 19.3061C10.4382 18.8607 10.6868 18.2559 10.6868 17.625H8.31179H5.93679C5.93679 18.2559 6.18542 18.8607 6.63073 19.3061C7.07605 19.7514 7.68093 20 8.31179 20C8.94265 20 9.54753 19.7514 9.99284 19.3061Z" fill="#276DBB" />
            </g>
            <circle cx="13.6798" cy="4.03916" r="3.0333" fill="#DD2E25" stroke="white" />
            <defs>
              <clipPath id="clip0_10219_8795">
                <rect width="16.625" height="19" fill="white" transform="translate(0 1)" />
              </clipPath>
            </defs>
          </svg>
          <span>
            To do
          </span>
        </h3>
        <div>
          <p class="flex gap-2 items-center mb-2">
            <span class="font-karma font-semibold text-[20px] text-(--ui-primary)">
              <span class="text-xl text-gray-800">
                <UiFaIcon :icon="['fal', 'circle-check']" />
              </span>
              Add tuition protection
            </span>
          </p>
          <div class="prose text-[14px]">
            <p>
              You're only half protected! Add <span class="font-semibold text-(--ui-primary)">
                Tuition Protection</span> to protect your college investment.
            </p>
          </div>
          <div class="flex justify-between mt-4">
            <UButton
              variant="outline"
              color="secondary"
              class="px-10"
            >
              Add
            </UButton>
            <button
              type="button"
              class="text-(--ui-neutral) text-xs font-semibold"
            >
              Dismiss
            </button>
          </div>
        </div>
      </div>
    </template>
  </LayoutLoggedBase>
</template>
